var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullReportOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -468) translate(0 456)"
  }, /*#__PURE__*/React.createElement("g", {
    "background-color": "#424a56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(24 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5l4-4 4 4 6-6v6zm0-8.5l-6 6-4-4-4 4V5h14v5.5zM13.5 9V6H12v6h1.5V9zm3.7 3l-2-3 2-3h-1.7l-2 3 2 3h1.7zM11 10.5H8.5v-.75H11V6H7v1.5h2.5v.75H7V12h4v-1.5z",
    transform: "translate(24 12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullReportOutline);
export default __webpack_public_path__ + "static/media/full-report-outline.7259c68e425161c3a5035c737ccd3232.svg";
export { ForwardRef as ReactComponent };